import { Component, ElementRef, OnInit } from '@angular/core';
import { NavigationService } from 'app-components';
import { AppIntegrationService, AppSettingsService } from 't4-app-integration';
import * as moment from 'moment';
import { PageBase, DiscountModel } from 't4core';
@Component({
  selector: 'app-invite-friends',
  templateUrl: './invite-friends.component.html',
  styleUrls: ['./invite-friends.component.css'],
  standalone: false
})
export class InviteFriendsComponent extends PageBase implements OnInit {    

  public discountModel: DiscountModel;
  public messageContent: string;
  public messageContentHeader: string;
  public appTitle: string;
  public appDescription: string;
  public loading: boolean = false;
  constructor(private navigator: NavigationService, el: ElementRef,
    private appSettings: AppSettingsService, private appIntegrationService: AppIntegrationService) {
    super(el);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.discountModel = await this.Api.get<DiscountModel>("/Campaign/GenerateCouponForInviteFriends", { bookingId: this.navigator.getParam('rentalId') });
    this.appTitle = await this.Translate.translate(this.discountModel.AppMessageTitle, '');
    this.appDescription = await this.Translate.translate(this.discountModel.AppMessageDescription, '');
    this.messageContent = await this.Translate.translate(this.discountModel.MessageContent, '');
    this.messageContentHeader = await this.Translate.translate(this.discountModel.MessageContentHeader, '');
    this.loading = false;
  }

  public back() {
    this.navigator.back();
  }

  openOffer() {
    const APP_URLS = {
      use4free: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.kanleiesandroid',
        ios: 'https://apps.apple.com/us/app/use4free/id1612470972',
        default: 'https://www.use4free.se/se/boka-online'
      },
      tysse_utleie: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.androidTysseRental',
        ios: 'https://apps.apple.com/us/app/tysse/id6479396425',
        default: 'https://tysse.no/utleie/bestillonline'
      },
      "24rental_se": {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.android24rental',
        ios: 'https://apps.apple.com/us/app/24rental/id1561167227',
        default: 'https://www.24rental.se/boka-online'
      },
      brenderuprental: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.bsgandroid',
        ios: 'https://apps.apple.com/us/app/brenderup-rental/id1572540717',
        default: 'https://www.brenderuprental.com/se/boka-slap'
      },
      "okq8_se": {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.okq8trailerandroid',
        ios: 'https://apps.apple.com/us/app/okq8-sl%C3%A4p/id1548277008',
        default: 'https://www.use4free.se/se/boka-online'//Need to get the proper url for okq8 slap 
      },
      maxbo: {
        android: 'https://play.google.com/store/apps/details?id=turbo.apps.bsgmaxbo',
        ios: 'https://apps.apple.com/us/app/maxbo-tilhenger/id1619084804',
        default: 'https://www.maxbo.no/tjenester/utleie-tilhenger/'
      }
    };

    let appUrl = '';
    var device = this.getMobileOperatingSystem();
    const themeKey = this.appSettings.settings.theme.toLowerCase().replace(/[^a-z0-9]/gi, '_');
    if (APP_URLS[themeKey]) {
      if (device == 'Android') {
        appUrl = APP_URLS[themeKey].android;
      } else if (device == 'iOS') {
        appUrl = APP_URLS[themeKey].ios;
      } else {
        appUrl = APP_URLS[themeKey].default;
      }
    } else {
      appUrl = 'https://www.use4free.se/se';
    }


    var message = this.messageContent;
    message = message.replace("**CODE**", this.discountModel.DiscountId);
    if (device == 'Android') {      
      this.appIntegrationService.shareOffer(message + appUrl);
    } else if (navigator.share) {
      navigator.share({
        title: '🚛 ' + this.messageContentHeader,
        text: message,
        url: appUrl
      }).then(() => {
        console.log('Thanks for sharing!');
      }).catch((error) => {
        console.error('Error sharing:', error);
      });
    } else {
      console.log('Sharing not supported');
    }
  }

  public getMobileOperatingSystem(): string {
    var userAgent = navigator.userAgent || navigator.vendor;

    if (/windows phone/i.test(userAgent)) {
      return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    var win: any = window;
    if (/iPad|iPhone|iPod/.test(userAgent) && !win.MSStream) {
      return "iOS";
    }

    return "unknown";
  }


  public confirm() {
    this.navigator.executeCommand("TakeMeHome");
  }
}
